import React from 'react';

import KuperShiftGroupT from '@global/models/KuperShiftGroup.ts';
import { CursorActionsItemT } from '@global/types.ts';

import More from '../components/More.tsx';

import { RenderColsT } from '../../types.ts';

import Status from './paysGroups/Status.tsx';

const renderKuperShiftsGroups: RenderColsT<'kuperShiftsGroups'> = function ({
    name: colName,
    item,
}) {
    const { otherData } = this.props;
    const kuperShiftGroup = item as KuperShiftGroupT;
    let content;
    let className;

    if (colName === 'name') {
        content = (
            <>
                <div className="v2table__text _mediumWeight">{kuperShiftGroup.name}</div>
            </>
        );
    }

    if (colName === 'count') {
        const getMoreActions = otherData?.getMoreActions as (data: {
            group: KuperShiftGroupT;
        }) => CursorActionsItemT[];
        const actions = getMoreActions({ group: kuperShiftGroup });

        className = '_full';

        content = (
            <>
                <Status allCount={kuperShiftGroup.count} count={kuperShiftGroup.successCount} />
                <More
                    id={`kuperShiftGroup-${kuperShiftGroup._id}`}
                    items={actions}
                    stopPropagation={true}
                />
            </>
        );
    }

    return { content, className };
};

export default renderKuperShiftsGroups;
